import { Injectable } from '@angular/core';
import { catchError, switchMap } from 'rxjs/operators';
import { Observable, throwError, from, EMPTY } from 'rxjs';

import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';

import { Router } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage.service';
import { HTTP_STATUS_CODES } from 'src/constants';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private localStorageService: LocalStorageService) { }

  // intercept(
  //   request: HttpRequest<unknown>,
  //   next: HttpHandler
  // ): Observable<HttpEvent<unknown>> {
  //   const token = this.localStorageService.getToken();
  //   if (token) {
  //     request = request.clone({
  //       headers: request.headers.set('Authorization', `Bearer ${token}`),
  //     });
  //   }
  //   return next.handle(request).pipe(
  //     catchError((error: HttpErrorResponse) => {
  //       console.log(error)
  //       if (error.status === HTTP_STATUS_CODES.UNAUTHORIZED) {
  //         this.localStorageService.clear()
  //         this.router.navigate(['/login']);
  //       }
  //       if (error.status === HTTP_STATUS_CODES.SERVER_ERROR) {
  //         console.log("server error")
  //       }
  //       console.log("throwing error")
  //       return throwError(() => error);
  //     })
  //   );
  // }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return from(this.localStorageService.getToken()).pipe(
      switchMap((token: string | null) => {
        if (token) {
          request = request.clone({
            headers: request.headers.set('Authorization', `Bearer ${token}`),
          });
        }
        return next.handle(request);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === HTTP_STATUS_CODES.UNAUTHORIZED) {
          this.localStorageService.clear();
          this.router.navigate(['/login']);
          return EMPTY;
        }
        if (error.status === HTTP_STATUS_CODES.SERVER_ERROR) {
          console.log('server error');
        }
        return throwError(() => error);
      })
    );
  }
}

// import { Injectable } from '@angular/core';
// import { catchError, switchMap } from 'rxjs/operators';
// import { Observable, from, throwError } from 'rxjs';
// import {
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpInterceptor,
//   HttpErrorResponse,
// } from '@angular/common/http';
// import { Router } from '@angular/router';
// import { LocalStorageService } from '../services/local-storage.service';
// import { HTTP_STATUS_CODES } from 'src/constants';

// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {
//   constructor(private router: Router, private localStorageService: LocalStorageService) {}

//   intercept(
//     request: HttpRequest<unknown>,
//     next: HttpHandler
//   ): Observable<HttpEvent<unknown>> {
//     return from(this.localStorageService.getToken()).pipe(
//       switchMap((token: string | null) => {
//         if (token) {
//           request = request.clone({
//             headers: request.headers.set('Authorization', `Bearer ${token}`),
//           });
//         }
//         return next.handle(request);
//       }),
//       catchError((error: HttpErrorResponse) => {
//         if (error.status === HTTP_STATUS_CODES.UNAUTHORIZED) {
//           this.localStorageService.clear();
//           this.router.navigate(['/login']);
//         }
//         if (error.status === HTTP_STATUS_CODES.SERVER_ERROR) {
//           console.log('server error');
//         }
//         return throwError(() => error);
//       })
//     );
//   }
// }

